// extracted by mini-css-extract-plugin
module.exports = {"bold":"BoldableText_bold__nDjEt","normal":"BoldableText_normal__voKT9"};